import {
  Avatar,
  Box,
  Button,
  Flex,
  Grid,
  Image,
  Skeleton,
  Text,
  UnstyledButton,
} from "@mantine/core";
import useStyles from "./style";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import LinePatternSvg from "../../components/Svgs/LinePatternSvg";
import { removeCookie, setCookie } from "../../utils";
import LinePatternSvg from "../../components/Svgs/LinePatternSvg";
import { getUserByEmail, selectedBusiness } from "../../services";
import { getProfile } from "../../services/profile";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { _login } from "../../store/reducers/auth";

const SelectBusniesses = () => {
  const { classes } = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [users, setUsers] = useState([]);
  // const [loadingCount, setLoadingCount] = useState(0);
  const user = location.state.res;
  console.log("🚀 ~ SelectBusniesses ~ user:", user);

  // useEffect(() => {
  //   const fetchUser = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await getUserByEmail({
  //         email: user?.user?.email || user?.email,
  //       });
  //       if (res?.status === 200) {
  //         setUsers(res?.data?.user);
  //         setLoading(false);
  //       }
  //     } catch (err) {
  //       setLoading(false);
  //       console.error("Error fetching user:", err);
  //     }
  //   };

  //   fetchUser();
  // }, []);

  const totalBusinesses = user?.length || 3;

  const handleBusinessSelect = async (item) => {
    console.log("🚀 ~ handleBusinessSelect ~ item:", item);
    // if (user?.twoFactorVerified === false) {
    //   navigate("/select-2fa-method", {
    //     state: { user: item },
    //   });
    // } else {
    // const res = await selectedBusiness({
    //   staff: item,
    // });
    // }

    setLoading(true);
    try {
      const res = await selectedBusiness({
        staff: item,
      });
      console.log("🚀 ~ handleBusinessSelect ~ res:", res);
      const is2FaAccess = res?.data?.staff?.is2FaAccess === true;
      console.log("🚀 ~ handleBusinessSelect ~ is2FaAccess:", is2FaAccess);

      // let { token } = res?.data;
      if (res?.status === 200) {
        console.log(
          "🚀 ~ handleBusinessSelect ~ res?.data?.token:",
          res?.data?.token
        );
        // if (is2FaAccess && res?.data?.token) {
        //   console.log("hitttttttttttttttt",);
        //   navigate("/select-2fa-method", {
        //     state: { user: res.data.staff },
        //   });
        //   return;
        // }
        if (res?.data?.staff?.twoFactorVerified && is2FaAccess) {
          navigate("/select-2fa-method", {
            state: { user: res.data.staff },
          });
        } else {
          setCookie(res?.data?.token, "token");
          dispatch(_login({ token: res?.data?.token }));
          await getProfile(true, res?.data?.token);
          navigate("/home");
        }
      }
      // let profile = await getProfile(true, token);
      // if (profile?.user?.user) {
      //   setCookie(token, "token");
      //   navigate("/home");
      // }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
    // try {
    //   const res = await selectedBusiness({
    //     staff: item,
    //   });
    //   console.log("🚀 ~ handleBusinessSelect ~ res:", res);
    //   // let { token } = res?.data;
    //   if (res?.status === 200) {
    //     navigate("/select-2fa-method", {
    //       state: { user: res.data.staff },
    //     });
    //   }
    //   // let profile = await getProfile(true, token);
    //   // if (profile?.user?.user) {
    //   //   setCookie(token, "token");
    //   //   navigate("/home");
    //   // }
    // } catch (err) {
    //   console.log(err);
    //   setLoading(false);
    // }
  };

  return (
    <Grid className={classes.container}>
      <Grid.Col span={12} md={6} className={classes.leftCol}>
        <Flex direction="column" align="center" className={classes.leftContent}>
          <Box className={classes.LogoBar} pr={14} pb={20} h={76} w="100%">
            <Image src="/assets/images/logo2.png" width={110} />
          </Box>
          <Flex
            direction="column"
            justify="center"
            gap={73}
            className={classes.optionsAndHdngWrapper}
          >
            <Text className={classes.hdng}>
              Welcome <b>{user?.name || ""}!</b>
            </Text>
            <Flex direction="column" w={"100%"} gap={20}>
              <Text className={classes.subHdng}>
                Please select an Organization to log into
              </Text>
              {loading
                ? [...Array(totalBusinesses)]?.map((_, idx) => (
                    <Skeleton key={idx} height={60} radius="md" width="100%" />
                  ))
                : user?.businesses?.map((item, index) => (
                    <UnstyledButton
                      key={index}
                      className={classes.facilityOption}
                      onClick={() => {
                        handleBusinessSelect(item);
                      }}
                      disabled={loading} // prevent double click
                      style={{
                        opacity: loading ? 0.5 : 1,
                        pointerEvents: loading ? "none" : "auto",
                      }}
                    >
                      <Avatar className="avatar" size={48} />
                      <Text className="facilityName">
                        {item?.business?.companyName || ""}
                      </Text>
                    </UnstyledButton>
                  ))}
            </Flex>
            <Flex
              justify="center"
              align="center"
              gap={4}
              className={classes.signoutLinkText}
            >
              <Text fz={14} fw={400} ff="Inter" color="#737373">
                Wrong account?
              </Text>

              <Link
                className="signoutLink"
                aria-label="logout button"
                to={"/"}
                onClick={() => {
                  removeCookie("token");
                  navigate("/login");
                }}
              >
                <span role="button" aria-label="Logout">
                  <Text fz={14} fw={500} ff="Inter">
                    Sign out
                  </Text>
                </span>
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Grid.Col>
      <Grid.Col span={12} md={6} className={classes.rightCol}>
        <Flex
          className={classes.rightContent}
          align="center"
          justify="flex-end"
        >
          <Box className={classes.linePattern1Parent}>
            <LinePatternSvg />
          </Box>
          <img
            src="/assets/images/skypoint-dashboard.png"
            alt="skypoint-dashboard"
            className={classes.dashboardImg}
          />
          <Box className={classes.linePattern2Parent}>
            <LinePatternSvg />
          </Box>
        </Flex>
      </Grid.Col>
    </Grid>
  );
};

export default SelectBusniesses;
